import { render } from "./TyreDetail.vue?vue&type=template&id=399f2951&scoped=true"
import script from "./TyreDetail.vue?vue&type=script&lang=js"
export * from "./TyreDetail.vue?vue&type=script&lang=js"

import "./TyreDetail.vue?vue&type=style&index=0&id=399f2951&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-399f2951"]])

export default __exports__